export default __webpack_public_path__ + "static/media/1.0acb9987.jpg";